/**
 * Stat counter (sections/stat-counter.liquid).
 *
 * Counts each [data-stat-number] from zero to its data-target the first
 * time its row enters the viewport. The settle curve is the theme's
 * standard ease-out: most of the travel happens early, so the number
 * feels like it is arriving rather than ticking. The exact target string
 * is written at 100% - the animation can never leave a rounding artefact
 * behind.
 *
 * Reduced motion, no IntersectionObserver, or no JS at all: the markup
 * already contains the finished number, and this file simply leaves it.
 */
(function () {
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Builds the odometer: each digit becomes a strip of 0-9 twice over, and
     rolls to the second copy of its own digit, so every column spins at
     least once before it lands. Columns finish left to right. The finished
     number stays readable to assistive tech through aria-label; the strips
     are hidden from it. */
  function animate(el) {
    var final = el.textContent.trim();
    if (!/[0-9]/.test(final)) return;
    var odo = document.createElement('span');
    odo.className = 'stat-odo';
    odo.setAttribute('aria-hidden', 'true');
    var digits = final.split('');
    var digitIndex = 0;
    digits.forEach(function (ch) {
      if (!/[0-9]/.test(ch)) {
        var plain = document.createElement('span');
        plain.textContent = ch;
        odo.appendChild(plain);
        return;
      }
      var col = document.createElement('span');
      col.className = 'stat-odo__digit';
      var strip = document.createElement('span');
      strip.className = 'stat-odo__strip';
      for (var i = 0; i < 20; i++) {
        var cell = document.createElement('span');
        cell.textContent = String(i % 10);
        strip.appendChild(cell);
      }
      strip.style.setProperty('--odo-to', String(10 + parseInt(ch, 10)));
      strip.style.setProperty('--odo-delay', (digitIndex * 0.12).toFixed(2) + 's');
      digitIndex++;
      col.appendChild(strip);
      odo.appendChild(col);
    });
    el.setAttribute('aria-label', final);
    el.textContent = '';
    el.appendChild(odo);
    /* Paint the strips at 0 first, then roll: the class has to arrive after
       a frame that has already laid them out, or there is nothing to
       transition from. */
    void odo.offsetWidth;
    window.requestAnimationFrame(function () {
      odo.classList.add('is-rolling');
    });
  }

  function setup(section) {
    var numbers = Array.prototype.slice.call(
      section.querySelectorAll('[data-stat-number]')
    );
    if (numbers.length === 0) return;
    if (reduceMotionQuery.matches || !('IntersectionObserver' in window)) return;

    var fired = false;
    var observer = new IntersectionObserver(
      function (entries) {
        if (fired || !entries[0].isIntersecting) return;
        fired = true;
        observer.disconnect();
        numbers.forEach(animate);
      },
      { threshold: 0.4 }
    );
    observer.observe(section);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.section-stat-counter').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
